const WIDTH = 8640;
const HEIGHT = 4096;
export { WIDTH, HEIGHT };
